import React, { useEffect } from "react";
import "aos/dist/aos.css";
import AOS from "aos";
import {
  FaHeadset,
  FaChartLine,
  FaLaptopCode,
  FaBox,
  FaHeart,
  FaShare,
} from "react-icons/fa";
import SectionHeader from "../../components/ui/HeaderSection";

const features = [
  {
    icon: <FaHeadset className="text-4xl text-gray-700" />,
    title: "Support",
    description:
      "Dukungan penuh untuk memastikan pengalaman Anda berjalan lancar.",
  },
  {
    icon: <FaChartLine className="text-4xl text-gray-700" />,
    title: "Sales",
    description:
      "Pilihan paket fleksibel yang sesuai dengan kebutuhan pernikahan Anda.",
  },
  {
    icon: <FaLaptopCode className="text-4xl text-gray-700" />,
    title: "Onboarding",
    description: "Proses pembuatan undangan yang mudah dan cepat, tanpa ribet.",
  },
  {
    icon: <FaBox className="text-4xl text-gray-700" />,
    title: "Product",
    description:
      "Desain eksklusif dan fitur interaktif untuk undangan yang lebih berkesan.",
  },
  {
    icon: <FaHeart className="text-4xl text-gray-700" />,
    title: "Quality",
    description:
      "Standar terbaik untuk memastikan undangan Anda tampil sempurna.",
  },
  {
    icon: <FaShare className="text-4xl text-gray-700" />,
    title: "Result",
    description: "Undangan digital siap dibagikan, praktis dan penuh kesan.",
  },
];

const FeaturesSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section id="features-section" className="py-16 px-4 md:px-10">
      <div
        className="flex flex-col items-center text-center mb-12"
        data-aos="fade-up"
      >
        <SectionHeader
          title="Nikmati Fitur Undangan Digital Anda"
          description="Sederhana, cepat, dan elegan - semuanya dalam satu platform!"
          color="#E98362"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-0 w-full max-w-5xl mx-auto">
        {features.map((feature, index) => {
          const isOnboarding = index === 2;
          const isLastColumn = (index + 1) % 3 === 0;
          const isLastRow = index >= features.length - 3;

          return (
            <div
              key={index}
              className={`relative ${
                index !== features.length - 1 ? "border-b border-gray-200" : ""
              }
              ${
                !isLastColumn && !isOnboarding
                  ? "md:border-r md:border-gray-200"
                  : ""
              }
              ${isLastRow ? "md:border-b-0" : ""}`}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="flex flex-col items-center text-center p-6 transition-all duration-300 hover:-translate-y-2">
                {feature.icon}
                <h3 className="text-lg font-semibold mt-4 text-gray-800">
                  {feature.title}
                </h3>
                <p className="text-gray-500 mt-2 text-sm px-2">
                  {feature.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FeaturesSection;
